

import React from 'react';
import '../styles/Thankyou.css';

const ThankyouPage = () => {
  return (
    <div className="thankyou-container">
      <img src="/assets/logo.png" alt="Success" style={{ width: '200px', marginBottom: '20px' }} />
      <h1>Terima kasih telah mendaftar!</h1>
      <span>
        Data Anda telah berhasil didaftarkan. <br/>
        Kami menantikan kehadiran Anda di acara kami. <br/><br/>
        Anumodanā, Semoga Jasa Kebajikan ini mengondisikan pencapaian Nibbana <br/>
        Sādhu Sādhu Sādhu 🙏
      </span>
    </div>
  );
}

export default ThankyouPage;